import React, { useState } from "react";
import GradientButton from "../Buttons/GradientButton/GradientButton";
import StyledSmText from "../../common/components/styledSmText/StyledSmText";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledH3Heading from "../../common/components/styledH3Heading/StyledH3Heading";
import { useSubscription } from "../../Hooks/api/useSubscription";

const SubscriptionCard = () => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const [inputEmail, setInputEmail] = useState("");
  const [isInputValid, setIsInputValid] = useState(true);
  // const [isSubscribed, setIsSubscribed] = useState(false);
  // const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const { mutate: subscribe ,isPending} = useSubscription();

  const handleInputChange = (e) => {
    const email = e.target.value;
    setInputEmail(email);
    setIsInputValid(validEmail(email));
  };

  const handleButtonClick = () => {
    if (!isInputValid) return;

      subscribe(inputEmail,
        {
        onSuccess: () => {
          setInputEmail("")
        },
      }
    );
  };

  const validEmail = (email) => {
    return emailRegex.test(email);
  };

  // const closeModal = () => {
  //   setShowUnsubscribeModal(false);
  // };

  // React.useEffect(() => {
  //   if (isSuccess) {
  //     setIsSubscribed(true);
  //   }
  // }, [isSuccess]);

  return (
    <div className="w-full h-full yellow-border LeftSideContainer flex flex-col gap-10 py-8 px-4 md:px-10 md:py-12">
      {/* Heading */}
      <div className="space-y-3">
        <StyledH3Heading>Subscribe For The Latest Updates!</StyledH3Heading>
        <StyledMdText>
          Let's keep in touch with us by subscribing to our newsletter. Stay
          up-to-date.
        </StyledMdText>
      </div>

      {/* Input */}
      <div className="space-y-2">
        <div className="relative flex flex-col md:flex-row justify-center items-center gap-4 w-full ">
          <div className="relative overflow-x-hidden w-[100%]">
            <input
              type="email"
              value={inputEmail}
              onChange={handleInputChange}
              className="w-[100%] text-md border border-bright-yellow rounded-md text-white px-3 h-[55px] pr-36 bg-transparent focus:outline focus:outline-bright-yellow"
              placeholder="Enter email"
              maxLength={40}
            />
          </div>
          {inputEmail.length>0 && !isInputValid && (
          <StyledSmText fontColor="text-red-600 text-left self-start md:absolute bottom-[-50%] left-0">
            Please enter a valid email address
          </StyledSmText>
        )}
          <GradientButton
            onClick={handleButtonClick}
            disabled={!isInputValid || inputEmail==="" || isPending}
            fontColor={"w-full md:w-auto md:absolute md:right-[5px] md:top-1.5 !px-[25px] !py-[10px]"}
            children={"Subscribe"}
          />
        </div>
       
      </div>

      {/* Unsubscribe Modal */}
      {/* {showUnsubscribeModal && (
        <UnsubscribeModal
          closeModal={closeModal}
          email={inputEmail}
          setEmail={setInputEmail}
          onUnsubscribeSuccess={() => {
            setIsSubscribed(false);
          }}
        />
      )} */}
    </div>
  );
};

export default SubscriptionCard;
